const AGENT_OFFICE_MOUNT = "/agent-office/";
import {embedRequested,getEmbedLease} from '@/features/saiEmbed/embedAccess';

export function buildAgentOfficeEmbedUrl(
  projectId: string,
  projectAgentId: string | null = null,
): string {
  const search = new URLSearchParams({
    source: "pm",
    projectId,
  });
  const exactProjectAgentId = String(projectAgentId ?? "").trim();
  if (exactProjectAgentId) search.set("projectAgentId", exactProjectAgentId);
  if(embedRequested())search.set('saiEmbed','1');
  return `${AGENT_OFFICE_MOUNT}?${search.toString()}`;
}

export function buildAgentOfficeProjectRoute(
  projectId: string,
  projectAgentId: string | null = null,
): string {
  const base = `/projects/${encodeURIComponent(projectId)}/agent-office`;
  const exactProjectAgentId = String(projectAgentId ?? "").trim();
  const search=new URLSearchParams();
  if(exactProjectAgentId)search.set('projectAgentId',exactProjectAgentId);
  if(embedRequested()){
    search.set('saiEmbed','1');search.set('workspace',getEmbedLease()?.workspace||new URLSearchParams(window.location.search).get('workspace')||'');
  }
  return search.size?`${base}?${search}`:base;
}
